import { toast as toastify } from 'react-toastify';
import style from './Toast.module.scss';

const Msg = ({ title, text, closeToast, toastProps, className }) => (
    <div className={style.toastText}>
        <h5>{title}</h5>
        <p>{text}</p>
    </div>
);

const CloseButton = ({ closeToast }) => (
    <div className={style.CloseButton}>
        <i className="bi bi-x" onClick={closeToast}></i>
    </div>
);

const errorIcon = () => (
    <div className={style.errorIconContainer}>
        <i className="bi bi-exclamation-lg"></i>
    </div>
);

const successIcon = () => (
    <div className={style.successIconContainer}>
        <i className="bi bi-check2"></i>
    </div>
);

const warningIcon = () => (
    <div className={style.warningIconContainer}>
        <i className="bi bi-exclamation-lg"></i>
    </div>
);

const infoIcon = () => (
    <div className={style.infoIconContainer}>
        <i className="bi bi-info-lg"></i>
    </div>
);

const Toast = {
    error(msg, options = {}, customTitle = null) {
        const isExpired = `${localStorage.getItem('isAuthExpired')}` === 'true';
        if (isExpired) return;
        return toastify.error(
            <Msg title={customTitle || 'Error'} text={msg} />,
            {
                hideProgressBar: true,
                className: style.toastErrorContainer,
                closeButton: CloseButton,
                icon: errorIcon,
                ...options,
            },
        );
    },
    success(msg, options = {}, customTitle = null) {
        return toastify.success(
            <Msg title={customTitle || 'Success'} text={msg} />,
            {
                hideProgressBar: true,
                className: style.toastSuccessContainer,
                closeButton: CloseButton,
                icon: successIcon,
                ...options,
            },
        );
    },
    warning(msg, options = {}, customTitle = null) {
        return toastify.warning(
            <Msg title={customTitle || 'Warning'} text={msg} />,
            {
                hideProgressBar: true,
                className: style.toastWarningContainer,
                closeButton: CloseButton,
                icon: warningIcon,
                ...options,
            },
        );
    },
    info(msg, options = {}, customTitle = null) {
        return toastify.info(<Msg title={customTitle || 'Info'} text={msg} />, {
            hideProgressBar: true,
            className: style.toastInfoContainer,
            closeButton: CloseButton,
            icon: infoIcon,
            ...options,
        });
    },
};

export default Toast;
